$(document).ready(function() {
  return $('.alert').fadeIn().delay(6000).fadeOut();
});
